/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ContactType, Formula } from '@gh/builder-shared-data';
import { createDialogRoute } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';

import { GtoEntryPoint } from './gto';

export interface ContactDetailsDialogConfig {
  contactId?: ID;
  contactType?: ContactType | ContactType[];
  parentTitle: string;
  entryPoint?: string;
  skipOfficeSetupFlowCheck?: boolean;
}

export interface TopDetailsDialogConfig {
  id?: ID;
  entryPoint?: string;
  entryId?: ID;
}

export interface FormulaPropagationDialogConfig {
  isComponent: boolean;
  formula: string;
  elementCode: string;
}

export interface FormulaPropagationHpListDialogConfig {
  formula: string;
  oldFormula?: Formula;
  costCenterId?: ID;
  elementId: ID;
  elementCode: string;
  isComponent: boolean;
  excludeIds?: ID[];
}

export interface GraphicalTakeOffMainConfig {
  title: string;
  entryPoint: GtoEntryPoint;
  id: ID;
  priceBookId?: ID;
  quickQuote: boolean;
  allTops?: any[];
  gFolderId: ID;
  isDisabledGto?: boolean;
}

export interface SalesManagementReportDialogConfig {
  forYear: number;
  forMonth: number;
}

export const contactDetailsDialogRoute = createDialogRoute<ContactDetailsDialogConfig>({
  lazy: {
    module: '/contacts',
    name: 'contactDetailsDialogRoute',
  },
});

export const topDetailsDialogRoute = createDialogRoute<TopDetailsDialogConfig>({
  lazy: {
    module: '/setup/estimating',
    name: 'topDetailsDialogRoute',
  },
});

export const formulaPropagationDialogRoute = createDialogRoute<FormulaPropagationDialogConfig>({
  lazy: {
    module: '/estimating',
    name: 'formulaPropagationDialogRoute',
  },
});

export const formulaPropagationHpListDialogRoute = createDialogRoute<FormulaPropagationHpListDialogConfig>({
  lazy: {
    module: '/estimating',
    name: 'formulaPropagationHpListDialogRoute',
  },
});

export const graphicalTakeOffMainDialogRoute = createDialogRoute<GraphicalTakeOffMainConfig>({
  lazy: {
    module: '/gto',
    name: 'graphicalTakeOffMainDialogRoute',
  },
});

export const salesManagementReportFilterDialogRoute = createDialogRoute<SalesManagementReportDialogConfig>({
  lazy: {
    module: '/sales',
    name: 'salesManagementReportFilterDialogRoute',
  },
});
